<template>
	<v-app>
		<v-card class="mx-auto overflow-hidden" height="100%" width="100%">
			<Navbar /><br><br><br>
			<v-card-text>
				<router-view />
				<loader></loader>
			</v-card-text>
		</v-card>
	</v-app>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  components: {
    Navbar
  },
  watch: {
    group () {
      this.drawer = false
    },
  },
  computed: {
    items () {
      let items = [
          { title: 'Register', icon: 'mdi-calendar-month',  route: 'Enroll'},
          { title: 'Signup', icon: 'mdi-shield',  route: 'Signup'},
          { title: 'Login', icon: 'mdi-lock-open-outline',  route: 'Signin'},
          { title: 'Faq', icon: 'mdi-email-outline',  route: 'Faq'}
        ]
      if ((this.loggedInUser ==='SuperAdmin') ) {
        items = [
          { title: 'Permissions', icon: 'mdi-account-group',  route: 'UserManagement'},
          { title: 'Membership', icon: 'mdi-database',  route: 'MembershipList'},
          { title: 'Events', icon: 'mdi-calendar-month',  route: 'ManageEvents'},
          { title: 'FrontDesk', icon: 'mdi-desk',  route: 'FrontDesk'},
          { title: 'BackStage', icon: 'mdi-desk-lamp',  route: 'PCheckIn'}
        ]
      } else if (this.loggedInUser ==='Admin') {
        items = [
          { title: 'ManageProgram', icon: 'mdi-database',  route: 'ManageCompetition'},
          { title: 'Membership', icon: 'mdi-database',  route: 'MembershipList'},
          { title: 'Events', icon: 'mdi-calendar-month',  route: 'ManageEvents'},
          { title: 'FrontDesk', icon: 'mdi-desk',  route: 'FrontDesk'},
          { title: 'BackStage', icon: 'mdi-desk-lamp',  route: 'PCheckIn'}
        ]
      } else if (this.loggedInUser ==='Member') {
        items = [
          { title: 'Faq', icon: 'mdi-email-outline',  route: 'Faq'}
        ]
      }
      return items
    },
    loggedInUser () {
      var user = this.$store.getters.email
      var role = this.$store.getters.role
      if (user && (role === "SuperAdmin")) return 'SuperAdmin'
      else if (user && (role === "Admin")) return 'Admin'
      else if (user && (role === "Member")) return 'Member'
      else return null
    }
  },
  methods: {
    goHome () {
      this.$router.replace('/')
    },
    navigateTo (item) {
      this.$router.push({name: item.route})
      },
    logoutFromFirebase () {
      this.$store.dispatch('signOutAction')
      .then(() => this.$router.replace('/Signin'))
      }
    },
    data: () => ({
      dialog: false,
      drawer: false,
      user: ''
    }),
  }
</script>
